const mainHost = () => {
  return window.location.host.includes('named.com') ? 'named.com' : 'nmd.co';
};

export default mainHost;
